module.exports = __webpack_public_path__ + "img/alert_doc.5973e52b.svg";